import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ExamdojoAgGridModule } from '@examdojo/ag-grid';
import { Tag } from '@examdojo/core/ontology';
import { SelectableTreeBaseComponent } from '@examdojo/core/tree';
import { SearchInputComponent } from '@examdojo/ui/input';
import { OntologyDomainExplorerCellRendererComponent } from './cell-renderer/ontology-domain-explorer-cell-renderer.component';
import { VerificationIndicator } from './domain-node.interface';

@Component({
  selector: 'exam-ontology-domain-explorer',
  standalone: true,
  imports: [ExamdojoAgGridModule, SearchInputComponent, MatSlideToggleModule, ReactiveFormsModule],
  templateUrl: './ontology-domain-explorer.component.html',
  styleUrls: ['./ontology-domain-explorer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full w-full' },
})
export class OntologyDomainExplorerComponent extends SelectableTreeBaseComponent<Tag, VerificationIndicator> {
  constructor() {
    super({
      autoGroupColumnDef: {
        headerName: 'Domains',
        cellRenderer: OntologyDomainExplorerCellRendererComponent,
        cellRendererParams: {
          suppressCount: true,
        },
        sort: 'asc',
        comparator: (valueA: string, valueB: string) => {
          return (valueA || '').toLowerCase().localeCompare((valueB || '').toLowerCase());
        },
      },
    });
  }

  readonly includeDependenciesChanged = output<boolean>();

  readonly searchCtrl = new FormControl<string>('', { nonNullable: true });
  readonly includeDependenciesCtrl = new FormControl<boolean>(false, { nonNullable: true });

  onSearch(value: string): void {
    if (this.gridApi) {
      this.gridApi.setGridOption('quickFilterText', value);
    }
  }
}
